// Libraries
var React = require('react');
var $ = require('jquery');

// Components
var CallToAction = require('../../common/CallToAction/CallToAction');

// Styles
require('./SplashScreen.scss');

class SplashScreen extends React.Component {

	componentDidMount = () => {
		function removeSplashScreen(event) {
			if(event.type === 'click' || event.key === 'Enter') {
				$('.SplashScreen').remove();
			}
		}

		$('.SplashScreen__navigation a.close').click(removeSplashScreen).keydown(removeSplashScreen);

		const picturefill = require('picturefill');	
		picturefill();

		this.bannerLink.focus();
	}

	render() {
		const images = this.props.data.image;

		return (
			<div className={"SplashScreen"}>
				<div className="SplashScreen__container">

					<div className="SplashScreen__leadimage">
						<a href={this.props.data.imageLink.url} ref={(banner) => {this.bannerLink = banner}}>
							<img data-src={images.smallUrl + '*,*' + images.mediumUrl + '*,*' + images.largeUrl + '*,*' + images.extraLargeUrl} alt={this.props.data.imageAltText || this.props.data.image.altText} />
						</a>
					</div>

					<div className="SplashScreen__navigation">
						<CallToAction linkStyle={this.props.data.leftLink.linkStyle} button="true" center="true" url={this.props.data.leftLink.url} newWindow={this.props.data.leftLink.newWindow} caption={this.props.data.leftLink.caption} />
						<CallToAction linkStyle={this.props.data.rightLink.linkStyle} button="true" center="true" url={this.props.data.rightLink.url} newWindow={this.props.data.rightLink.newWindow} caption={this.props.data.rightLink.caption} />
					</div>

				</div>
			</div>
		)
	}
}

module.exports = SplashScreen;



// WEBPACK FOOTER //
// ./src/components/SplashScreen/SplashScreenModule.js